export enum ExpandIconPosition {
  Start = 'start',
  End = 'end',
  Right = 'right',
  Left = 'left'
}
